import {
  CV_NODE_SELECTED,
  CV_PREV_NODE_SELECTED,
  CV_SET_MENU_DATA,
} from '../actions/action-creator';

const initialState = {
  error: null,
  loading: false,
  main: {},
  selected: null,
  previousSelected: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CV_SET_MENU_DATA:
      return {
        ...state,
        error: null,
        loading: false,
        main: action.payload,
      };
    case CV_NODE_SELECTED:
      return {
        ...state,
        error: null,
        loading: false,
        selected: action.payload,
      };
    case CV_PREV_NODE_SELECTED:
      return {
        ...state,
        error: null,
        loading: false,
        previousSelected: action.payload,
      };
    default:
      return state;
  }
};
